import { faTv } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Stack, Slider, NumberInput } from '@mantine/core'
import {
  sliderValueToInchesMapping,
  convertTvSizeValueToInches as convertSliderValueToInches,
  convertIncheseToSelectedSliderValue,
} from '../../../utils/deviceSizeUtils'
import { useState } from 'react'
import classes from '../../css/DeviceSize.module.css'

interface DeviceSizeProps {
  deviceSize: number | null
  setDeviceSize: (value: number | null) => void
}

export const DeviceSize = (props: DeviceSizeProps) => {
  const { deviceSize, setDeviceSize } = props
  const [screenSizeSliderValue, setScreenSizeSliderValue] = useState(
    convertIncheseToSelectedSliderValue(deviceSize ?? 0),
  )

  const handleScreenSizeChange = (val: string | number) => {
    if (typeof val === 'number') {
      const sliderValue = convertIncheseToSelectedSliderValue(val)
      setDeviceSize(val)
      setScreenSizeSliderValue(sliderValue)
    }
  }
  const handleSliderChange = (val: number) => {
    const inches = convertSliderValueToInches(val)
    if (inches !== null) {
      setDeviceSize(inches)
    }
    setScreenSizeSliderValue(val)
  }

  return (
    <Stack w='80%' h='80%' align='center'>
      <Stack
        h='300px'
        style={{
          justifyItems: 'center',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <FontAwesomeIcon
          icon={faTv}
          style={{
            height: Math.max(
              100 + (Math.min(deviceSize ?? 50, 80) - 50) * 2,
              50,
            ),
          }}
        />
        <NumberInput
          placeholder='18"'
          style={{ justifySelf: 'flex-end' }}
          value={deviceSize ?? ''}
          onChange={(val) => handleScreenSizeChange(val)}
          w='100%'
          suffix='"'
          clampBehavior='blur'
          allowLeadingZeros={false}
          min={1}
          max={200}
          variant='unstyled'
          fw={1000}
          hideControls
          size='100px'
          classNames={{ input: classes.pricingInput }}
        />
      </Stack>

      <Slider
        visibleFrom='sm'
        marks={sliderValueToInchesMapping.map((x) => ({
          value: x.sliderValue,
          label: x.inches ? `${x.inches}"` : 'Custom',
        }))}
        w='100%'
        maw={1000}
        max={10}
        pt={32}
        label={(val) =>
          sliderValueToInchesMapping.find((mark) => mark.sliderValue === val)!
            .inches
        }
        styles={{ label: { display: 'none' } }}
        value={screenSizeSliderValue ?? 10}
        onChange={(val) => handleSliderChange(val)}
      />
    </Stack>
  )
}
